<template>
    <v-navigation-drawer
       v-model="opened"
       height="100vh"
       width="350"
       location="right"
       floating
       fixed
       temporary
       hide-overlay
       class="drawer-info">

       <div class="header-drawer">
         <span >Detalles</span>
           <v-icon class="mr-2"
           @click="opened = false">
             mdi-close
           </v-icon>
       </div>

        <div class="container-data-drawer-row" v-if="order">
            <div class="container-element-drawer-two-coloms">
                <span class="title-elemet-drawer">Creado</span>
                <span class="element-drawer"> {{ formatTimestamp(order.created) }}</span>
            </div>

            <div class="container-element-drawer-two-coloms" >
                <span class="title-elemet-drawer">No. Orden</span>
                <span class="element-drawer"> #{{order.folio}} </span>
            </div>

            <div class="container-element-drawer-two-coloms">
                <span class="title-elemet-drawer">Punto de Venta</span>
                <span class="element-drawer"> {{order.terminal.name}} </span>
            </div>

            <div class="container-element-drawer-two-coloms">
                <span class="title-elemet-drawer">Cant. Productos</span>
                <span class="element-drawer"> {{ getProducts(order.products)}} </span>
            </div>

            <div class="container-element-drawer-two-coloms">
                <span class="title-elemet-drawer">Monto</span>
                <span class="element-drawer">${{order.amount}} </span>
            </div>

            <div class="container-element-drawer-two-coloms">
                <span class="title-elemet-drawer">Estatus</span>
                <span class="element-drawer"> {{getStatus (order.status) }} </span>
            </div>

            <div class="container-element-drawer">
                <span class="title-elemet-drawer">Pago</span>
                <span class="element-drawer">
                  {{ getMethod(order.method)}} = ${{order.amount  }}
                </span>
            </div>

            <div class="line-divider"></div>

             <div class="container-element-drawer">
                <span class="title-elemet-drawer">Productos</span>
            </div>

             <div v-for="item in order.products" :key="item._id"
             class="container-element-drawer-row">
                <span class="element-drawer">{{ item.quantity }} X {{item.name}}</span>
                <span class="element-drawer"> ${{ item.price}}</span>
            </div>

        </div>

    </v-navigation-drawer>
</template>

<script>
import dateTransform from '@/utils/dateTransform'
export default {
  name: 'CommerciaVueOrderDrawer',

  data () {
    return {
      opened: false,
      order: null
    }
  },

  methods: {
    show (order) {
      this.opened = true
      this.order = order
    },
    formatTimestamp (timestamp) {
      return dateTransform.timestampToFormat(timestamp)
    },
    getProducts (products) {
      let contProducts = 0
      for (const item of products) {
        contProducts += item.quantity
      }
      return contProducts
    },
    getMethod (method) {
      switch (method) {
        case 'cash':
          return 'Efectivo'
        case 'transfer':
          return 'Transferencia'
        case 'debit':
          return 'Debito'
        case 'credit':
          return 'Credito'
        case 'open':
          return 'Abierto'
        default:
          return 'Combinado'
      }
    },
    getStatus (status) {
      switch (status) {
        case 'new':
          return 'Nueva'
        case 'preparing':
          return 'Preparando'
        case 'ready':
          return 'Lista para entrega'
        case 'delivered':
          return 'Entregada'
        case 'canceled':
          return 'Cancelada'
      }
    }
  }
}
</script>

<style scoped>
  @import '@/assets/styles/drawers.css';
</style>
